import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import CityForm from '../components/forms/CityForm';
import '../styles/EmployeeMaster.css';
import CityTable from '../components/CityTable';

const CityEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [cityData, setCityData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /sbu/edit
  const showModal = location.pathname.startsWith('/city/edit');

  const handleCloseModal = () => {
    navigate('/city'); // Go back to list
  };

  // ✅ Fetch SBU details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getCityById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setCityData(data.data);
          } else {
            setCityData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching SBU by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>City Master</h2>
      </div>

      {/* Table of SBUs */}
      <CityTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit City</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : cityData ? (
            <CityForm cityId={id} initialData={cityData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this City.</p>
          )}
        </Modal.Body>
       
      </Modal>
    </div>
  );
};

export default CityEditModel;
